import BaseWebPlusAd from "./WebPlusAd";
import Container from "../components/Container";
import Header from "../components/Header";
import SubHeader from "../components/SubHeader";
import { WEB_PLUS_SHIPPING_THRESHOLD } from "./constants";

export default BaseWebPlusAd;
export { Container, Header, SubHeader, WEB_PLUS_SHIPPING_THRESHOLD };
